import { createDOMElement } from '../../helpers/fixtureUtils';
import { PRIVATE_EVENTS, PUBLIC_EVENTS, EVENT_CALLBACK } from '../../handlers/EventManager/constants';
import StandingsService from '../../services/StandingsService';
import { ASSETS_IMAGES_BASE_URL } from '../../constants/AssetConstants';
import './index.scss';
import { JSON_IMAGE_BASE_URL } from '../../constants/FixtureConstants';
export default class StandingsWidgetMulti {
    constructor(sportsManager, standingsConfig) {
        this.standingWidgetData = null;
        this.standingsConfig = standingsConfig
        this.assetConfig = this.standingsConfig.assetConfig
        this.jsonConfig = this.standingsConfig.jsonManagerConfig
        this.sportsManager = sportsManager;
        if (!this.sportsManager) {
            throw new Error('Sports manager is required in standings Multi view.');
        }

        this.eventManager = this.sportsManager.eventManager;
        if (!this.eventManager) {
            throw new Error('Event manager is required in standings Multi view.');
        }
        this.parentElement = document.getElementById(this.assetConfig.parentId) || '';

        if(!this.parentElement){
            this.eventManager.broadcastPublicEvent(PUBLIC_EVENTS.SPORTS_MANAGER_ERROR, {
                errorCode: 'err_100',
                errorMessage: 'DOM element required to render tab view.',
            });
        }
        this.sportsId = this.assetConfig.sportsId;
        this.tournmentId = this.assetConfig.tournamentId;

        if(!this.sportsId || !this.tournmentId) {
            this.eventManager.broadcastPublicEvent(PUBLIC_EVENTS.SPORTS_MANAGER_ERROR, {
                errorCode: 'err_100',
                errorMessage: 'Sports id and tournament is required in standings Multi view.',
            });
        }

        this.widgetCallback = this.assetConfig.widgetCallback;
        this.handleSetHref = this.assetConfig.handleSetHref;

        this.subscribeToEvents();
    }

    subscribeToEvents() {
        this.eventManager.subscribeToEvents({
            eventType: EVENT_CALLBACK.PRIVATE_EVENTS,
            eventCallback: this.privateEventCallback.bind(this),
            senderName: 'STANDING_FULL_PAGE_SERVICE',
        });
    }

    privateEventCallback(eventName, eventData) {
        switch (eventName) {
            case PRIVATE_EVENTS.STANDINGS_FULL_PAGE_UPDATE: {
                this.standingWidgetData = eventData?.standingWidgetData;
                this.standingMetaData = eventData?.standingsMetaData;
                this.render()
                break;
            }

            default: {
                console.log('Uncaught event');
                break;
            }
        }
    }

    getStandingsData() {
        const standingsService = new StandingsService(this.sportsManager);
        standingsService.fetchStandingsData(PRIVATE_EVENTS.STANDINGS_FULL_PAGE_UPDATE, this.sportsId, this.tournmentId,"standings", this.jsonConfig);
    }

    createElement(parent, className, id, innerHTML) {
        const dom = {
            ele: "div",
            attributes: {
                class: className,
            },
            parent,
            innerHTML
        }
        const element = createDOMElement(dom);
        if (id) {
            this.elementStore[id] = element;
        }
        return element;
    }

    renderStandingGroupRow(rowData,parentContainer,index) {
        const teamPosition = rowData?.position_status == "Up" ? "teamUp" : rowData?.position_status == "No change" ? "teamNoChange" : "teamDown"
        const standingGroupTeamCard = this.createElement(parentContainer, `standing-group-team-container-card ${teamPosition}`);
        const standingGroupTeamDescCard = this.createElement(standingGroupTeamCard, "standing-group-desc-container-card");
        const groupTeamNumber = this.createElement(standingGroupTeamDescCard, "standing-group-team-number-container","",index);
        const groupTeamArrow = document.createElement('img');
        groupTeamArrow.setAttribute('class', 'standing-team-arrow-container');
        groupTeamArrow.src = rowData?.position_status == "Up" ? `${ASSETS_IMAGES_BASE_URL}/Chevron_up.svg` : `${ASSETS_IMAGES_BASE_URL}/Chevron_down.svg`;;
        standingGroupTeamDescCard.appendChild(groupTeamArrow);
        const groupLogoOuterCont = document.createElement('a');
        groupLogoOuterCont.setAttribute('class', "standing-group-team-logo-outer-wrapper");
        this.handleSetHref("SET_HREF", rowData?.team_metadata, (route, isHrefEnabled) => {
            groupLogoOuterCont.href = route
            if(isHrefEnabled === false) {
                groupLogoOuterCont.classList.add("disablePointer")
            } 
        });
        standingGroupTeamDescCard.appendChild(groupLogoOuterCont);
        const groupTeamLogo = document.createElement('img');
        groupTeamLogo.setAttribute('class', 'standing-group-team-logo-container');

        let imageEndPoint = this.jsonConfig?.imageEndPoint ? this.jsonConfig?.imageEndPoint : JSON_IMAGE_BASE_URL;

        // groupTeamLogo.src = "https://player-dev.sonyliv.com/platform/web/sportssdk/asset/country_flags/24.png";
        groupTeamLogo.src = `${imageEndPoint}/${this.sportsId}/${rowData.team_id}.png`;
        groupTeamLogo.onerror = function (e) {
            groupTeamLogo.src = `${ASSETS_IMAGES_BASE_URL}/counrty_flag_logo_fallback_image.svg`;
        }
        groupTeamLogo.alt = rowData?.team_short_name;
        groupLogoOuterCont.appendChild(groupTeamLogo);
        const groupTeamTitle = document.createElement('a');
        groupTeamTitle.setAttribute('class', "standing-group-team-title-container");
        this.handleSetHref("SET_HREF", rowData?.team_metadata, (route, isHrefEnabled) => {
            groupTeamTitle.href = route
            if(isHrefEnabled === false) {
                groupTeamTitle.classList.add("disablePointer")
            } 
        });
        groupTeamTitle.innerText = rowData?.team_short_name;
        standingGroupTeamDescCard.appendChild(groupTeamTitle);
        // const groupTeamTitle = this.createElement(standingGroupTeamDescCard, "standing-group-team-title-container","",rowData?.team_short_name);
        
        const standingGroupTeamScoreCard = this.createElement(standingGroupTeamCard, "standing-group-team-score-card");
        const groupTeamMtitle = this.createElement(standingGroupTeamScoreCard, "standing-card-team-title standing-group-team-Mtitle-container","",rowData?.played);
        const groupTeamWtitle = this.createElement(standingGroupTeamScoreCard, "standing-card-team-title standing-group-team-Wtitle-container","",rowData?.wins);
        const groupTeamDtitle = this.createElement(standingGroupTeamScoreCard, "standing-card-team-title standing-group-team-Dtitle-container","",rowData?.draws);
        const groupTeamLtitle = this.createElement(standingGroupTeamScoreCard, "standing-card-team-title standing-group-team-Ltitle-container","",rowData?.lost);
        const groupTeamPtstitle = this.createElement(standingGroupTeamScoreCard, "standing-card-team-title standing-group-team-pts-container","",rowData?.points);
    }

    renderGroupStandingsCard(standings,parentEle) {
        const standingGroupCont = this.createElement(parentEle, "standing-group-container");
        const standingGroupInnerCont = this.createElement(standingGroupCont, "standing-group-inner-container");
        const standingGroupCardTitleCont = this.createElement(standingGroupInnerCont, "standing-group-title-container");
        const groupCardtitle = this.createElement(standingGroupCardTitleCont, "standing-card-title-container-text","",standings?.name);
        const standingGroupInningsCont = this.createElement(standingGroupCardTitleCont, "standing-group-innings-container");
        const groupCardMtitle = this.createElement(standingGroupInningsCont, "standing-card-team-title standing-card-Mtitle-container","","M");
        const groupCardWtitle = this.createElement(standingGroupInningsCont, "standing-card-team-title standing-card-Wtitle-container","","W");
        const groupCardDtitle = this.createElement(standingGroupInningsCont, "standing-card-team-title standing-card-Dtitle-container","","D");
        const groupCardLtitle = this.createElement(standingGroupInningsCont, "standing-card-team-title standing-card-Ltitle-container","","L");
        const groupCardPtstitle = this.createElement(standingGroupInningsCont, "standing-card-team-title standing-card-pts-title-container","","Pts");
        standings?.teams?.team.map((rowData,index)=> {
            this.renderStandingGroupRow(rowData,standingGroupInnerCont,index+1)
        })

    }

    render() {
        if(this.standingWidgetData?.length > 0) {
            const standingAllContainer = this.createElement(this.parentElement, "standing-all-container");
            const standingAllInnerContainer = this.createElement(standingAllContainer, "standing-all-inner-container");
            this.standingWidgetData.map((standings) => {
                this.renderGroupStandingsCard(standings,standingAllInnerContainer)
            })
            this.widgetCallback("STANDINGS_MULTI_RENDER_SUCCESS")
        }
    }
}

// export default StandingsWidgetMulti